// extracted by mini-css-extract-plugin
export default {"root":"dropdown-module--root--F4U6j","option":"dropdown-module--option--GFCxm","flag":"dropdown-module--flag--iOtlZ"};